<iframe
  *ngIf="assetUrl"
  #ref
  [src]="assetUrl"
  [style.minHeight]="minHeight"
  (load)="onIframeLoad(ref)"
  frameborder="0"
></iframe>
